import exchangeChart from "./images/exchange-chart.png";
import marketsChart from "./images/markets-chart.png";
import neshaneMelliSabt from "./images/neshane-melli-sabt.png";
import qrCode from "./images/qr-code.png";

const tempMedia = { exchangeChart, marketsChart, neshaneMelliSabt, qrCode };

export default tempMedia;
